import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../../constants/svgIcon';
import {
  getQuickCreateGameModeProps,
  QuickCreateGameMode,
} from '../../../../models/DraftStore';
import { WebBoosterType } from '../../../../models/UserStore';
import { AppBar, PngIcon, SvgIcon } from '../../../Molecules';

import styles from './CreateMemoryGameProcessedContentTemplate.module.css';

interface CreateMemoryGameProcessedContentTemplateProps {
  type: QuickCreateGameMode | undefined;
  webBoosterType: WebBoosterType | undefined;
  language: string;
  gameContents: string[];
  isNextDisabled: boolean;
  isExceedLimit: boolean;
  isFlashing: boolean;
  expectedPayment: number;
  onClickLanguage: () => void;
  onClickBack: () => void;
  onClickNext: () => void;
}

export const CreateMemoryGameProcessedContentTemplate = (
  props: CreateMemoryGameProcessedContentTemplateProps,
) => {
  const {
    type,
    webBoosterType,
    language,
    gameContents,
    isNextDisabled,
    isExceedLimit,
    isFlashing,
    expectedPayment,
    onClickLanguage,
    onClickNext,
    onClickBack,
  } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.createMemoryProcessContent}>
      <AppBar
        title={
          type ? t(getQuickCreateGameModeProps(type, webBoosterType).name) : ''
        }
        onClickBack={onClickBack}
        trailing={
          <>
            {expectedPayment !== 0 && (
              <div className={styles.paymentContainer}>
                <PngIcon name={'CreationStamina'} width={24} height={24} />
                {`${t('Pay: ')}${expectedPayment}`}
              </div>
            )}
          </>
        }
      />
      <div className={styles.container}>
        <div className={styles.titleContainer}>
          {/* <p className={styles.gameTypeName}>
            {t(getQuickCreateGameModeProps(type).name)}
          </p> */}
          <p className={styles.gameTypeName}>{t('Processed Content')}</p>
          <p className={styles.orangeDescription}>
            {t(
              'Each {type} is limited to {wordCount} words and {lineCount} line breaks. When your source content is too long, it will be divided into multiple practices.',
              {
                type: t(
                  type
                    ? getQuickCreateGameModeProps(type, webBoosterType).name
                    : '',
                ),
                wordCount: type
                  ? getQuickCreateGameModeProps(type, webBoosterType)
                      .splitLimitation
                  : 0,
                lineCount: 5,
              },
            )}
          </p>
        </div>

        <div className={styles.buttonContainer} onClick={onClickLanguage}>
          <div className={styles.languageSelector}>
            <SvgIcon
              name={SVGIconType.LanguageA}
              width={28}
              height={28}
              color={'white'}
            />
            <span className={styles.language}>{t(language)}</span>
            <SvgIcon
              name={SVGIconType.Triangle}
              width={20}
              height={20}
              color={'white'}
            />
          </div>
        </div>

        <div className={styles.cellHeader}>
          <p className={styles.title}>{t('Learning Content')}</p>
          {isExceedLimit ? (
            <p
              className={`${styles.maxGameCount} ${
                isFlashing ? styles.flash : ''
              }`}
            >
              {t('(max. {count})', { count: 20 })}
            </p>
          ) : null}
        </div>

        {gameContents.map((gamecontent, index) => (
          <div key={index} className={styles.gameCard}>
            <div className={styles.gameFooter}>
              <div className={styles.gameNumber}>{index + 1}</div>
            </div>
            <div className={styles.gameHeader}>
              <div className={styles.cardContent}>{gamecontent}</div>
            </div>
          </div>
        ))}

        {isExceedLimit ? (
          <p
            className={`${styles.maxGameBottomCount} ${
              isFlashing ? styles.flash : ''
            }`}
          >
            {t('(max. {count})', { count: 20 })}
          </p>
        ) : null}
      </div>
      <div className={styles.bottomBar}>
        <div className={styles.nextContainer}>
          <button className={styles.okButton} onClick={onClickBack}>
            <SvgIcon
              className={styles.leftArrowIcon}
              name={SVGIconType.Arrow}
            />
            <span className={styles.okText}>{t('Back')}</span>
          </button>
          <button
            className={styles.okButton}
            onClick={onClickNext}
            disabled={isNextDisabled}
          >
            <span className={styles.okText}>{t('OK')}</span>
            <SvgIcon
              className={styles.rightArrowIcon}
              name={SVGIconType.Arrow}
            />
            {isNextDisabled ? <div className={styles.blackShadow} /> : null}
          </button>
        </div>
      </div>
    </div>
  );
};
